import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface PortalSidebarState {
  collapsed: boolean;
  mobileOpen: boolean;
  toggle: () => void;
  setCollapsed: (v: boolean) => void;
  openMobile: () => void;
  closeMobile: () => void;
}

export const usePortalSidebarStore = create<PortalSidebarState>()(
  persist(
    (set) => ({
      collapsed:    false,
      mobileOpen:   false,
      toggle:       () => set((s) => ({ collapsed: !s.collapsed })),
      setCollapsed: (v) => set({ collapsed: v }),
      openMobile:   () => set({ mobileOpen: true }),
      closeMobile:  () => set({ mobileOpen: false }),
    }),
    { name: 'grc-portal-sidebar', partialize: (s) => ({ collapsed: s.collapsed }) },
  ),
);
